module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_5_CIUDADANO.c9fb4237.jpg";